const props = {
    fill: "currentColor",
    "aria-hidden": true,
    focusable: false,
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
};

export const AggravatedDamage = (
    <svg viewBox="0 0 320 512" {...props}>
        <path d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
    </svg>
);

export const SuperficialDamage = (
    <svg viewBox="0 0 352 512" {...props}>
        <path d="M342.8,155.9c12.3-12.3,12.3-32.2,0-44.5l-22.2-22.2c-12.3-12.3-32.2-12.3-44.5,0L9.2,356.1c-12.3,12.3-12.3,32.2,0,44.5l22.2,22.2c12.3,12.3,32.2,12.3,44.5,0L342.8,155.9z" />
    </svg>
);

// this is used as a placeholder to ensure sizing is consistent
export const NoDamage = (
    <svg viewBox="0 0 352 512" {...props}></svg>
);

// instakill icon
export const Instakill = (
    <svg viewBox="0 0 512 512" {...props}>
        <path d="M416 400V464C416 490.5 394.5 512 368 512H320V464C320 455.2 312.8 448 304 448C295.2 448 288 455.2 288 464V512H224V464C224 455.2 216.8 448 208 448C199.2 448 192 455.2 192 464V512H144C117.5 512 96 490.5 96 464V400C96 399.6 96 399.3 96.01 398.9C37.48 357.8 0 294.7 0 224C0 100.3 114.6 0 256 0C397.4 0 512 100.3 512 224C512 294.7 474.5 357.8 415.1 398.9C415.1 399.3 416 399.6 416 400V400zM160 192C124.7 192 96 220.7 96 256C96 291.3 124.7 320 160 320C195.3 320 224 291.3 224 256C224 220.7 195.3 192 160 192zM352 320C387.3 320 416 291.3 416 256C416 220.7 387.3 192 352 192C316.7 192 288 220.7 288 256C288 291.3 316.7 320 352 320z" />
    </svg>
);

export const Instaheal = (
    <svg viewBox="0 0 512 512" {...props}>
        <path d="M0 190.9V185.1C0 115.2 50.52 55.58 119.4 44.1C164.1 36.51 211.4 51.37 244 84.02L256 96L267.1 84.02C300.6 51.37 347 36.51 392.6 44.1C461.5 55.58 512 115.2 512 185.1V190.9C512 232.4 494.8 272.1 464.4 300.4L283.7 469.1C276.2 476.1 266.3 480 256 480C245.7 480 235.8 476.1 228.3 469.1L47.59 300.4C17.23 272.1 .0003 232.4 .0003 190.9L0 190.9z" />
    </svg>
);

export const Help = (
    <svg viewBox="0 0 512 512" {...props}>
        <path d="M102.1,151.7c0-19.5,6.3-39.2,18.8-59.2c12.5-20,30.8-36.6,54.8-49.7c24-13.1,52-19.7,84-19.7c29.7,0,56,5.5,78.8,16.5
            c22.8,11,40.4,25.9,52.8,44.8c12.4,18.9,18.6,39.4,18.6,61.5c0,17.4-3.5,32.7-10.6,45.9c-7.1,13.1-15.5,24.5-25.2,34
            c-9.7,9.5-27.2,25.6-52.5,48.2c-7,6.4-12.6,12-16.8,16.8c-4.2,4.8-7.3,9.2-9.4,13.2c-2.1,4-3.6,8-4.8,12c-1.1,4-2.8,11-5.1,21.1
            c-3.9,21.3-16.1,32-36.6,32c-10.7,0-19.6-3.5-26.9-10.5c-7.3-7-10.9-17.3-10.9-31.1c0-17.2,2.7-32.2,8-44.8
            c5.3-12.6,12.4-23.7,21.2-33.2c8.8-9.5,20.7-20.9,35.7-34c13.1-11.5,22.6-20.2,28.5-26s10.8-12.4,14.8-19.5c4-7.2,6-15,6-23.4
            c0-16.4-6.1-30.3-18.3-41.5C294.7,93.6,279,88,259.7,88c-22.6,0-39.2,5.7-49.9,17.1c-10.7,11.4-19.7,28.2-27.1,50.3
            c-7,23.2-20.2,34.8-39.7,34.8c-11.5,0-21.2-4-29.1-12.2C106.1,169.9,102.1,161.1,102.1,151.7z M252.3,489
            c-12.5,0-23.4-4.1-32.8-12.2c-9.3-8.1-14-19.4-14-34c0-12.9,4.5-23.8,13.5-32.6c9-8.8,20.1-13.2,33.2-13.2
            c12.9,0,23.8,4.4,32.6,13.2c8.8,8.8,13.2,19.7,13.2,32.6c0,14.4-4.6,25.6-13.8,33.9C275.1,484.8,264.4,489,252.3,489z"
        />
    </svg>
);
